import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetBankRecon } from './useGetBankRecon'
import { BankReconContent } from './BankReconContent'

export const BankReconComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetBankRecon(id, tileFilterSelections)

  return (
    <BankReconContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function BankReconComponentLoading() {
  return 'Loading...'
}
